import React from "react";
import Credencial from "../Credencial/Credencial";
import logoMPF from './../../Images/logo-mpf.png';

function CredencialContainer() {
  return (
    <>
      <div className="App">
        <header className="App-header">
          <img src={logoMPF} className="App-logo mt-5" alt="logo" />
          <div className="w-100">
            <Credencial />
          </div>
        </header>
      </div>
    </>
  );
}

export default CredencialContainer;